import React from "react";
import { useAuth } from "../../contexts/AuthContext";

interface RouteProtectionProps {
  children: React.ReactNode;
  routePath: string;
}

export const RouteProtection: React.FC<RouteProtectionProps> = ({
  children,
  routePath,
}) => {
  const { sidebarData } = useAuth();

  // If no sidebar data yet, show loading
  if (!sidebarData) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Check if the current route is in the user's allowed routes
  const isRouteAllowed =
    sidebarData.allowed_routes?.includes(routePath) || false;

  if (!isRouteAllowed) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-900">
        <div className="text-center p-8 bg-slate-800 rounded-lg border border-slate-700 max-w-md">
          <div className="mb-4">
            <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
              <svg
                className="w-8 h-8 text-red-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
                />
              </svg>
            </div>
          </div>
          <h2 className="text-2xl font-bold text-white mb-3">
            Permission Not Allowed
          </h2>
          <p className="text-slate-300 mb-6">
            {`You don't have permission to access this page. Please contact your
            administrator if you believe this is an error.`}
          </p>
          <div className="text-sm text-slate-400">
            Route:{" "}
            <code className="bg-slate-700 px-2 py-1 rounded">{routePath}</code>
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
